module.exports = __webpack_public_path__ + "assets/img/36_585.0d808853.jpg";